import {
  ProcessFlowchartErrorType,
  ProcessFlowchartForValidation,
  ProcessFlowchartValidationError,
} from 'processes/graph-builder-processes/validation/ProcessFlowchartForValidationTypes';
import {ProcessFlowchartDesignSpace} from 'processes/graph-builder-processes/validation/ProcessGraphBuilderConstants';

/**
 * A flowchart validator is used to run app-specific flowchart validation and self-healing behavior.
 *
 * These validations get run within client/processes/graph-builder-processes/validation/validateProcessFlowchart.ts
 */
export abstract class FlowchartValidator {
  abstract validateFlowchartForType(
    flowchart: ProcessFlowchartForValidation,
    designSpace: ProcessFlowchartDesignSpace,
    didInitialFlowchartHaveChainedRouters: boolean,
    disconnectedNodeIds?: Array<string>
  ): Array<ProcessFlowchartValidationError>;
  /**
   * A mapping of validation error types to the message to override the default with, if any.
   */
  abstract readonly errorTypeToMessageOverride: Partial<Record<ProcessFlowchartErrorType, string>>;
}
